import { getMixpanel } from '@domain-group/fe-helper';
import { getBaseProps } from '..';
import getEntryPoint from '../get-entry-point';

const trackViewLandingPage = (serverReferer?: string): void => {
  try {
    const mixpanel = getMixpanel();
    const entryPoint = getEntryPoint({ serverReferer });

    mixpanel.track('View FAA Landing Page', {
      ...getBaseProps(),
      entryPoint,
      siteSection: 'Agents',
    });
  } catch {
    throw new Error('Failed to track View FAA Landing Page event');
  }
};

export default trackViewLandingPage;
